import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ddefaf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-div-corpo" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-campo-info" }, "E")
], -1))
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, { label: "Filtrar por" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "Selecione",
                  value: _ctx.dados.computedBuscaAvancada.filtroSelecionado,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.filtroSelecionado) = $event)),
                  onChange: _ctx.filtroAlterado
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dados.computedBuscaAvancada.filtros, (filtro) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: filtro.identificador,
                        value: filtro.identificador
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(filtro.apresentacao), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: "Condição",
              class: "margin-condicao"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "Selecione",
                  value: _ctx.dados.computedBuscaAvancada.condicaoSelecionada,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.condicaoSelecionada) = $event)),
                  disabled: _ctx.desabilitarCamposAteSelecionarFiltro()
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dados.computedBuscaAvancada.condicoes, (condicao) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: condicao.codigo,
                        value: condicao.codigo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(condicao.descricao), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, {
              label: "Valor/Informação",
              class: "margin-condicao"
            }, {
              default: _withCtx(() => [
                ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.Padrao) && _ctx.condicaoComValorUnico())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.dados.computedBuscaAvancada.tipoDadoFiltroSelecionado === _ctx.ETipoDado.VerdadeiroFalso)
                        ? (_openBlock(), _createBlock(_component_a_switch, {
                            key: 0,
                            class: "ss-tamanho-completo",
                            checked: _ctx.dados.computedBuscaAvancada.primeiroValor,
                            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                            disabled: _ctx.desabilitarCamposAteSelecionarFiltro()
                          }, null, 8, ["checked", "disabled"]))
                        : (_ctx.tipoDadoFiltroData())
                          ? (_openBlock(), _createBlock(_component_a_date_picker, {
                              key: 1,
                              value: _ctx.dados.computedBuscaAvancada.primeiroValor,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                              format: _ctx.dados.formatoData,
                              valueFormat: _ctx.dados.formatoDataValor,
                              "show-time": _ctx.dados.exibirHoras,
                              class: "ss-tamanho-completo",
                              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"])),
                              disabled: _ctx.desabilitarCamposAteSelecionarFiltro()
                            }, null, 8, ["value", "format", "valueFormat", "show-time", "disabled"]))
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 2,
                              type: "text",
                              placeholder: "Digite aqui",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                              onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
                              onPaste: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validarInformacaoColada($event))),
                              class: "ss-tamanho-completo ant-input",
                              disabled: _ctx.desabilitarCamposAteSelecionarFiltro(),
                              onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                            }, null, 40, _hoisted_6)), [
                              [_vModelText, _ctx.dados.computedBuscaAvancada.primeiroValor]
                            ])
                    ], 64))
                  : ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.Padrao) && _ctx.condicaoComDoisValores())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (_ctx.tipoDadoFiltroData())
                            ? (_openBlock(), _createBlock(_component_a_date_picker, {
                                key: 0,
                                value: _ctx.dados.computedBuscaAvancada.primeiroValor,
                                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                                format: _ctx.dados.formatoData,
                                valueFormat: _ctx.dados.formatoDataValor,
                                "show-time": _ctx.dados.exibirHoras,
                                onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"])),
                                class: "ss-tamanho-completo"
                              }, null, 8, ["value", "format", "valueFormat", "show-time"]))
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "text",
                                onKeypress: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
                                onPaste: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validarInformacaoColada($event))),
                                class: "ant-input ss-tamanho-completo",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                                onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                              }, null, 544)), [
                                [_vModelText, _ctx.dados.computedBuscaAvancada.primeiroValor]
                              ])
                        ]),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          (_ctx.tipoDadoFiltroData())
                            ? (_openBlock(), _createBlock(_component_a_date_picker, {
                                key: 0,
                                value: _ctx.dados.computedBuscaAvancada.segundoValor,
                                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.segundoValor) = $event)),
                                format: _ctx.dados.formatoData,
                                valueFormat: _ctx.dados.formatoDataValor,
                                "show-time": _ctx.dados.exibirHoras,
                                class: "ss-tamanho-completo",
                                onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                              }, null, 8, ["value", "format", "valueFormat", "show-time"]))
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "text",
                                onKeypress: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
                                onPaste: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validarInformacaoColada($event))),
                                class: "ant-input ss-tamanho-completo",
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.segundoValor) = $event)),
                                onKeyup: _cache[20] || (_cache[20] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                              }, null, 544)), [
                                [_vModelText, _ctx.dados.computedBuscaAvancada.segundoValor]
                              ])
                        ])
                      ]))
                    : ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.Padrao) && (_ctx.condicaoComListaValores()))
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 2,
                          value: _ctx.dados.computedBuscaAvancada.valores,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.valores) = $event)),
                          mode: "tags",
                          style: {"width":"100%"},
                          placeholder: "Digite sua informação e tecle 'Enter' para confirmar",
                          onKeypress: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
                          onPaste: [
                            _cache[23] || (_cache[23] = ($event: any) => (_ctx.validarInformacaoColada($event))),
                            _cache[24] || (_cache[24] = _withModifiers(() => {}, ["prevent"]))
                          ],
                          allowClear: true,
                          notFoundContent: null,
                          onChange: _ctx.selecionarVariosItens,
                          onKeyup: _cache[25] || (_cache[25] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                        }, null, 8, ["value", "onChange"]))
                      : ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.RecursoAssociado) && (_ctx.condicaoComValorUnico()))
                        ? (_openBlock(), _createBlock(_component_a_select, {
                            key: 3,
                            value: _ctx.dados.computedBuscaAvancada.primeiroValor,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                            "show-search": "",
                            allowClear: true,
                            placeholder: "Digite um valor para pesquisar",
                            style: {"width":"100%"},
                            "filter-option": false,
                            "not-found-content": _ctx.dados.fetching ? undefined : null,
                            options: _ctx.dados.resultadoConsulta,
                            onSearch: _ctx.pesquisaAutoCompletar,
                            onChange: _ctx.selecionaUnicoItem,
                            onKeyup: _cache[27] || (_cache[27] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                          }, _createSlots({ _: 2 }, [
                            (_ctx.dados.fetching)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_a_spin, { size: "small" })
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "not-found-content", "options", "onSearch", "onChange"]))
                        : ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.RecursoAssociado) && (_ctx.condicaoComListaValores()))
                          ? (_openBlock(), _createBlock(_component_a_select, {
                              key: 4,
                              value: _ctx.dados.computedBuscaAvancada.valores,
                              "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.valores) = $event)),
                              "show-search": "",
                              mode: "multiple",
                              allowClear: true,
                              placeholder: "Digite um valor para pesquisar",
                              style: {"width":"100%"},
                              "filter-option": false,
                              "not-found-content": _ctx.dados.fetching ? undefined : null,
                              options: _ctx.dados.resultadoConsulta,
                              onSearch: _ctx.pesquisaAutoCompletar,
                              onChange: _ctx.selecionarVariosItens,
                              onKeyup: _cache[29] || (_cache[29] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                            }, _createSlots({ _: 2 }, [
                              (_ctx.dados.fetching)
                                ? {
                                    name: "notFoundContent",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_a_spin, { size: "small" })
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["value", "not-found-content", "options", "onSearch", "onChange"]))
                          : ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.ListaItens) && (_ctx.condicaoComValorUnico()))
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 5,
                                value: _ctx.dados.computedBuscaAvancada.primeiroValor,
                                "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.primeiroValor) = $event)),
                                allowClear: true,
                                placeholder: "Selecione",
                                style: {"width":"100%"},
                                options: _ctx.dados.listaItens,
                                onChange: _ctx.selecionaUnicoItem,
                                onKeyup: _cache[31] || (_cache[31] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                              }, null, 8, ["value", "options", "onChange"]))
                            : ((_ctx.dados.tipoFiltro === _ctx.ETipoFiltro.ListaItens) && (_ctx.condicaoComListaValores()))
                              ? (_openBlock(), _createBlock(_component_a_select, {
                                  key: 6,
                                  value: _ctx.dados.computedBuscaAvancada.valores,
                                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.dados.computedBuscaAvancada.valores) = $event)),
                                  "show-search": "",
                                  mode: "multiple",
                                  allowClear: true,
                                  placeholder: "Digite um valor para pesquisar",
                                  style: {"width":"100%"},
                                  options: _ctx.dados.listaItens,
                                  onChange: _ctx.selecionarVariosItens,
                                  onKeyup: _cache[33] || (_cache[33] = _withKeys(($event: any) => (_ctx.adicionarFiltro()), ["enter"]))
                                }, null, 8, ["value", "options", "onChange"]))
                              : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-block ant-btn-secondary ss-acao-destaque-secundaria",
                  disabled: _ctx.desabilitarCamposAteSelecionarFiltro(),
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.adicionarFiltro && _ctx.adicionarFiltro(...args)))
                }, " Adicionar ", 8, _hoisted_12)
              ]),
              _: 1
            })
          ])
        ]),
        ((!_ctx.UtilitarioGeral.validaLista(_ctx.dados.computedBuscaAvancada.filtrosAdicionados)))
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              adicionarDado: true,
              mensagem: "Nenhum filtro foi adicionado ainda."
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Filtros adicionados")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { style: {"padding-top":"5px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dados.computedBuscaAvancada.filtrosAdicionados, (filtro, index) => {
                      return (_openBlock(), _createBlock(_component_a_tag, {
                        key: filtro.codigo,
                        onClose: () => _ctx.removerFiltro(filtro.codigo),
                        closable: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.atualizarOperador(filtro.codigo)),
                            class: _normalizeClass([index === 0 ? 'ss-ocultar' : 'ss-operador-filtro'])
                          }, _toDisplayString(_ctx.obtenhaTextoOperador(filtro.filtro.operador)), 11, _hoisted_15),
                          _createElementVNode("b", null, _toDisplayString(filtro.apresentacao), 1),
                          _createTextVNode(" " + _toDisplayString(filtro.detalhes), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClose"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.limparFiltros && _ctx.limparFiltros(...args))),
                  type: "button",
                  class: "ant-btn ant-btn-block ant-btn-secondary"
                }, "Limpar filtros")
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}